//
// social-index/index.js - kick-off for social index
//

let el_si_selector = document.getElementsByClassName('js-si-selector');
if (el_si_selector.length > 0) {
  require('./renderers');
  require('./controllers');
  require('./responsive-detail-view');
}
